import { FormActionsMui } from '@app/components/form/actions/FormActionsMui';
import { SocialPlatform } from '@app/modules/social-export/domain/platforms';
import { publishMessages } from '@app/modules/social-export/publish/publish-messages';
import { ReactNode } from 'react';
import { useIntl } from 'react-intl';

export type SocialPublishFormActionsProps = {
  platform: SocialPlatform;
  /** When true, disables submit if the form is invalid (e.g. TikTok disclosure). */
  disableSubmitIfInvalid?: boolean;
  /** Tooltip shown when submit is disabled for a form-specific reason. */
  submitDisabledTooltip?: ReactNode;
};

/**
 * Shared publish form footer: cancel + submit labeled with the destination platform name and icon.
 */
export function SocialPublishFormActions({
  platform,
  disableSubmitIfInvalid,
  submitDisabledTooltip,
}: SocialPublishFormActionsProps) {
  const { $t } = useIntl();

  return (
    <FormActionsMui
      separator
      saveIcon={platform.Icon()}
      saveLabel={$t(publishMessages.sendToPlatform, { platformName: platform.name })}
      cancel
      disableSubmitIfInvalid={disableSubmitIfInvalid}
      submitDisabledTooltip={submitDisabledTooltip}
    />
  );
}
